<template>
  <div v-if="live">
    <b-row>
      <b-col> <h3>{{ live.name }}</h3></b-col>
      <b-col>
        <div class="text-right">
          <span>{{ live.statusName }}</span>
        <b-button :disabled="live.status != 1" @click="stopLive" variant="success" class="ml-3">
          <div>
            <font-awesome-icon icon="user-plus" />
            <span class="ml-2">Stop Live</span>
          </div>
        </b-button>
        <b-button variant="outline-primary" class="ml-1">
          <div>
            <font-awesome-icon icon="user-plus" />
            <span class="ml-2">Live Detail</span>
          </div>
        </b-button>
        <router-link :to="`/live/edit/${live.postTypeId}/${live.id}`">
          <b-button variant="outline-primary" class="ml-1">
            <div>
              <font-awesome-icon icon="user-plus" />
              <span class="ml-2">Edit</span>
            </div>
          </b-button>
        </router-link>
        </div>
      </b-col>
    </b-row>
    <!-- <div class="d-flex justify-content-between align-items-center">
      <span class="unit-font text-break">
        <h3>{{ live.name }}</h3>
      </span>
      <span class="text-break">
        <span>{{ live.statusName }}</span>
        <b-button variant="success" class="ml-3">
          <div>
            <font-awesome-icon icon="user-plus" />
            <span class="ml-2">Stop Live</span>
          </div>
        </b-button>
        <b-button variant="outline-primary" class="ml-1">
          <div>
            <font-awesome-icon icon="user-plus" />
            <span class="ml-2">Live Detail</span>
          </div>
        </b-button>
        <router-link :to="`/live/edit/${live.postTypeId}/${live.id}`">
          <b-button variant="outline-primary" class="ml-1">
            <div>
              <font-awesome-icon icon="user-plus" />
              <span class="ml-2">Edit</span>
            </div>
          </b-button>
        </router-link>
      </span>
    </div> -->
    <b-row>
      <b-col
        ><div class="mt-3 bg-white p-3">
          <h5>ENGAGEMENT</h5>
          <b-row>
            <b-col sm="2">Like</b-col>
            <b-col sm="8">
              <div class="pt-1">
                <b-progress
                  :value="live.likeCount"
                  :max="
                    Math.max(live.likeCount, live.commentCount, live.orderCount)
                  "
                ></b-progress></div
            ></b-col>
            <b-col sm="2">{{ live.likeCount }}</b-col>

            <b-col sm="2">Comment</b-col>
            <b-col sm="8">
              <div class="pt-1">
                <b-progress
                  :value="live.commentCount"
                  :max="
                    Math.max(live.likeCount, live.commentCount, live.orderCount)
                  "
                ></b-progress></div
            ></b-col>
            <b-col sm="2">{{ live.commentCount }}</b-col>

            <b-col sm="2">Confirm</b-col>
            <b-col sm="8">
              <div class="pt-1">
                <b-progress
                  :value="live.orderCount"
                  :max="
                    Math.max(live.likeCount, live.commentCount, live.orderCount)
                  "
                ></b-progress></div
            ></b-col>
            <b-col sm="2">{{ live.orderCount }}</b-col></b-row
          >
        </div></b-col
      >
      <b-col>
        <b-row>
          <b-col
            ><div class="mt-3 bg-white p-3 h-100">
              <h5>PAYMENT SUMMARY</h5>
              <div class="d-flex justify-content-between align-items-center">
                <span class="unit-font text-break">Total sale:</span>
                <span class="text-break overview-number">
                  ฿ {{ live.grandTotal | numeral("0,0.00") }}
                </span>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <span class="unit-font text-break">Wait for pay:</span>
                <span class="text-break overview-number">
                  ฿ {{ live.waitPayTotal | numeral("0,0.00") }}
                </span>
              </div>
            </div></b-col
          >
          <b-col
            ><div class="mt-3 bg-white p-3 h-100">
              <h5>DATE/TIME</h5>
              <div class="d-flex justify-content-between align-items-center">
                <span class="unit-font text-break">From date:</span>
                <span class="text-break">
                  {{ new Date(live.startDate) | moment($formatDateTime) }}
                </span>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <span class="unit-font text-break">To date:</span>
                <span class="text-break" v-if="live.endDate">
                  {{ new Date(live.endDate) | moment($formatDateTime) }}
                </span>
              </div>
            </div></b-col
          >
        </b-row>
      </b-col>
    </b-row>
    <div class="mt-3 bg-white p-3">
      <div>
        <b-tabs content-class="mt-1">
          <b-tab title="คำสั่งซื้อ" active><OrderTable :liveId="id" /> </b-tab>
          <b-tab title="คีย์เวิร์ดที่ลูกค้าพิมพ์"
            ><KeywordTable :liveId="id"/>
            <p></p
          ></b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>

<script>
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import OrderTable from "./Component/OrderTable.vue";
import KeywordTable from "./Component/KeywordTable.vue";
export default {
  name: "LiveDetail",
  components: {
    ModalAlert,
    ModalAlertError,
    ModalAlertConfirm,
    OrderTable,
    KeywordTable,
  },
  data() {
    return {
      id: this.$route.params.id,
      live: null,
    };
  },
  async created() {
    this.getDetail();
  },
  methods: {
    stopLive: async function(){
      await this.axios
        .get(`${this.$baseUrl}/livePost/endlive/${this.live.id}`)
        .then((data) => {
          console.log("stop live", data);
          if (data.result == 1) {
            this.getDetail()
          }
        });
    },
    getDetail: async function() {
      await this.axios
        .get(`${this.$baseUrl}/livePost/${this.id}`)
        .then((data) => {
          console.log("get live detail", data);
          if (data.result == 1) {
            this.live = data.detail;
          }
        });
    },
  },
};
</script>
